import React from 'react';
import { useAccordionContext } from './hooks';

export type AccordionToggleType = {
    element?: React.ElementType;
    eventKey?: string | number;
    children?: React.ReactNode | React.ReactNode[];
    extraClass?: string;
    onClick?: (event?: any) => void;
    isActive?: boolean;
    hasCloseActionIcon?: boolean;
    contentId?: string;
    tag?: 'h2' | 'h3' | 'div';
};

export type UseAccordionClickHandlerType = (
    eventKey: AccordionToggleType['eventKey'],
    onClick: AccordionToggleType['onClick']
) => void;

const useAccordionClick: UseAccordionClickHandlerType = (eventKey, onClick) => {
    const { onToggle, activeEventKey } = useAccordionContext();

    return (event: any) => {
        if (onToggle) {
            onToggle(eventKey === activeEventKey ? null : eventKey);
        }

        if (onClick) {
            onClick(event);
        }
    };
};

const AccordionToggle: React.FC<AccordionToggleType> = ({
    element: Component = 'div',
    eventKey,
    onClick,
    children,
    ...otherProps
}) => {
    const accordionClick = useAccordionClick(eventKey, onClick);

    return (
        <Component onClick={accordionClick} {...otherProps}>
            {children}
        </Component>
    );
};
export default AccordionToggle;
